var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDepartmentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16.803,
    viewBox: "0 0 24 16.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "graduation-cap-solid",
    d: "M11.985,32a2.653,2.653,0,0,0-.889.154L.578,35.952a.9.9,0,0,0,0,1.695l2.171.784a6.173,6.173,0,0,0-.964,3.315V42.8a7.114,7.114,0,0,1-.836,3.03,9.942,9.942,0,0,1-.844,1.41.6.6,0,0,0,.334.945l2.4.6A.6.6,0,0,0,3.3,48.71a.587.587,0,0,0,.266-.39,9.668,9.668,0,0,0-.079-4.076,8.292,8.292,0,0,0-.506-1.575v-.922A4.98,4.98,0,0,1,4.031,38.69a4.579,4.579,0,0,1,1.845-1.339l5.887-2.314a.6.6,0,0,1,.439,1.114L6.315,38.465a3.442,3.442,0,0,0-1.207.81l5.985,2.16a2.645,2.645,0,0,0,1.777,0l10.522-3.787a.9.9,0,0,0,0-1.695l-10.519-3.8A2.653,2.653,0,0,0,11.985,32Zm-7.2,14.1c0,1.324,3.225,2.7,7.2,2.7s7.2-1.376,7.2-2.7l-.574-5.452-5.332,1.927a3.832,3.832,0,0,1-2.587,0L5.359,40.647Z",
    transform: "translate(0.015 -32)",
    fill: "#686868"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentIcon);
export default __webpack_public_path__ + "static/media/department-icon.145974ab2bc1e3afeeaf7b5875bb690c.svg";
export { ForwardRef as ReactComponent };